import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "surface-section p-4" }
const _hoisted_2 = { class: "font-medium text-3xl text-900 mb-3 flex justify-content-between card-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap gap-2 p-1"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "list-none p-0 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      ($props.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!$setup.edit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-pencil",
                    label: "Chỉnh sửa",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.edit = true))
                  })
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.edit)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-success",
                  icon: "pi pi-check",
                  label: "Hoàn tất",
                  loading: $setup.saving,
                  onClick: $setup.update
                }, null, 8 /* PROPS */, ["loading"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Button, {
              class: "p-button-success",
              icon: "pi pi-save",
              label: "Tạo cây mới",
              loading: $setup.saving,
              onClick: $setup.create
            }, null, 8 /* PROPS */, ["loading"])
          ]))
    ]),
    _createElementVNode("ul", _hoisted_7, [
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($props.plant.name) = $event)),
        edit: $setup.edit,
        label: "Tên gọi"
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.alias,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($props.plant.alias) = $event)),
        edit: $setup.edit,
        label: "Tên khác"
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.class,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($props.plant.class) = $event)),
        edit: $setup.edit,
        label: "Lớp"
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.scienceName,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($props.plant.scienceName) = $event)),
        edit: $setup.edit,
        label: "Tên khoa học"
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.description,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($props.plant.description) = $event)),
        edit: $setup.edit,
        label: "Mô tả",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.distribution,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($props.plant.distribution) = $event)),
        edit: $setup.edit,
        label: "Phân bổ",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.collection,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($props.plant.collection) = $event)),
        edit: $setup.edit,
        label: "Thu hoạch",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.feature,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($props.plant.feature) = $event)),
        edit: $setup.edit,
        label: "Tác dụng",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.recipe,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($props.plant.recipe) = $event)),
        edit: $setup.edit,
        label: "Công thức",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"]),
      _createVNode($setup["RowField"], {
        modelValue: $props.plant.notes,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($props.plant.notes) = $event)),
        edit: $setup.edit,
        label: "Ghi chú",
        "multi-line": true,
        rows: 5
      }, null, 8 /* PROPS */, ["modelValue", "edit"])
    ])
  ]))
}